import { render } from "./PartnerBill.vue?vue&type=template&id=c351b7b0"
import script from "./PartnerBill.vue?vue&type=script&lang=js"
export * from "./PartnerBill.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__